import React from 'react';
import './Card.css';

// Glass card primitive — wraps any panel/section with the platform's brand
// chrome. Use it to unify the look of older admin sub-panels (SMM, Products,
// etc.) without rewriting their internals.
//
// Usage:
//   <Card title="Service catalog" actions={<Button>New</Button>} meta="142 active">
//     ...panel body...
//   </Card>
//
// Props:
//   title:    string | node (shown in the head)
//   actions:  node — right side of the head (buttons, menus)
//   meta:     string | node — small label under/beside the title
//   tone:     'default' | 'warn' | 'danger' — adjusts the top accent line
//   noPad:    true to drop the inner padding (e.g. for full-width tables)
//   className: passthrough

const Card = ({ title, actions, meta, tone = 'default', noPad, className = '', children }) => {
  return (
    <section className={`ps-card ps-card--${tone} ${noPad ? 'ps-card--no-pad' : ''} ${className}`}>
      {(title || actions || meta) && (
        <header className="ps-card-head">
          <div className="ps-card-head-text">
            {title && <h3 className="ps-card-title">{title}</h3>}
            {meta && <span className="ps-card-meta">{meta}</span>}
          </div>
          {actions && <div className="ps-card-head-actions">{actions}</div>}
        </header>
      )}
      <div className={`ps-card-body ${noPad ? 'ps-card-body--no-pad' : ''}`}>{children}</div>
    </section>
  );
};

export default Card;
